module.exports = __webpack_public_path__ + "img/sec1_slide02.64dacee4.jpg";